import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

class MyPageHeader extends Component {
  componentDidMount() {}

  render() {
    const { t } = this.props;
    const activeClassName = 'active';

    return (
      <div className="setting_header">
        <div className="setting_header_inner">
          <div className="setting_header_box">
            <nav className="setting_lnb">
              <NavLink to="/my_page/bookmark" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}>
                {t('my_page.bookmark')}
              </NavLink>
              <NavLink to="/my_page/issue" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}>
                {t('my_page.issues')}
              </NavLink>
              <NavLink to="/my_page/scan_options" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}>
                {t('my_page.scan_options')}
              </NavLink>
              <NavLink to="/my_page/export_options" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}>
                {t('my_page.export_options')}
              </NavLink>
              <NavLink to="/my_page/connections" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}>
                {t('my_page.connections')}
              </NavLink>
              <NavLink to="/my_page/notifications" className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}>
                {t('my_page.notifications')}
              </NavLink>
            </nav>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(MyPageHeader);
